import { useMutation } from "react-query";
import http from "infra/http";
import { showErrorAxios } from "infra/helpers/alerta";

function useCriarGrupoImpressaoBoleto() {
  return useMutation(
    async (ids: string[]) => {
      const { data } = await http.post(`/v1/boleto/multiplo/grupo`, {
        ids,
      });

      return data as { hash: string };
    },
    {
      retry: false,
      onError: (e) => {
        showErrorAxios(e);
      },
    }
  );
}

export default useCriarGrupoImpressaoBoleto;
